import { deleteFile, uploadFileCIF } from "@/api/bid";

// Export the constants
// export const FILE_TYPES = {
//   BUSINESS: "business",
//   INDIVIDUAL: "individual",
//   CWCOT: "cwcot",
// };
export const FILE_TYPES = {
  BUSINESS: "business",
  INDIVIDUAL: "individual",
  CWCOT: "cwcot",
  CWCOT_HUD_NONPROFIT: "cwcotHudNonProfit",
  CWCOT_GOVERNMENT: "cwcotGovernment",
  HUD_NONPROFIT: "hudNonProfit",
  GOVERNMENT: "government",
  NONPROFIT_CORP: "nonProfitCorp",
  LAND_TRUST: "landTrust",
  HOUSING_COOP: "housingCoop",
  OWNER_OCCUPIED: "ownerOccupied",
  CALIFORNIA: "california",
  // ... existing types ...
  CA_BILL_OWNER_OCCUPIED: "caBillOwnerOccupied",
  CA_BILL_NON_PROFIT: "caBillNonProfit",
  CA_BILL_LAND_TRUST: "caBillLandTrust",
  CA_BILL_HOUSING_COOP: "caBillHousingCoop",
  CA_BILL_CALIFORNIA_STATE: "caBillCaliforniaState",
};
// You might also want to add a utility function to check if an entity type is CWCOT
export const isCWCOTEntityType = (entityType) => {
  return [
    FILE_TYPES.CWCOT_HUD_NONPROFIT,
    FILE_TYPES.CWCOT_GOVERNMENT,
    FILE_TYPES.HUD_NONPROFIT,
    FILE_TYPES.GOVERNMENT,
    FILE_TYPES.NONPROFIT_CORP,
    FILE_TYPES.LAND_TRUST,
    FILE_TYPES.HOUSING_COOP,
    FILE_TYPES.OWNER_OCCUPIED,
    FILE_TYPES.CALIFORNIA,
  ].includes(entityType);
};
export const isCABillEntityType = (entityType) => {
  return [
    FILE_TYPES.CA_BILL_OWNER_OCCUPIED,
    FILE_TYPES.CA_BILL_NON_PROFIT,
    FILE_TYPES.CA_BILL_LAND_TRUST,
    FILE_TYPES.CA_BILL_HOUSING_COOP,
    FILE_TYPES.CA_BILL_CALIFORNIA_STATE,
  ].includes(entityType);
};
export const FILE_CATEGORIES = {
  LLC: "LLC",
  CWCOT: "CWCOT",
  USER_FUND_PROOF: "USER_FUND_PROOF",
  // ... existing categories ...
  CA_BILL: "CA_BILL",
};

export const FILE_SUB_CATEGORIES = {
  LLC_BUYER: "LLC-buyer",
  LLC_COBUYER: "LLC-cobuyer",
  CWCOT_BUYER_SELF: "CWCOT-buyerself",
  CWCOT_BUYER_GOVT: "CWCOT-buyergovt",
  CWCOT_OWNER_OCCUPIED: "CWCOT-ca-owneroccupied",
  CWCOT_NONPROFIT: "CWCOT-ca-nonprofitcorp",
  CWCOT_LAND_TRUST: "CWCOT-ca-communitytrustland",
  CWCOT_COOP: "CWCOT-ca-limitedequhousingco",
  CWCOT_STATE: "CWCOT-ca-stateofclaifornia",
  CWCOT_CA_BUYER_GOVT: "CWCOT-ca-buyergovt",
  // ... existing categories ...
  CA_BILL_OWNER_OCCUPIED: "ca-bill-owneroccupied",
  CA_BILL_NON_PROFIT: "ca-bill-nonprofitcorp",
  CA_BILL_LAND_TRUST: "ca-bill-communitytrustland",
  CA_BILL_HOUSING_COOP: "ca-bill-limitedequhousingco",
  CA_BILL_CALIFORNIA_STATE: "ca-bill-stateofclaifornia",
};

export const getFileConfig = (entityType, isCoBuyer, primaryEntityType) => {
  if (entityType === FILE_TYPES.BUSINESS) {
    return {
      fileCategory: FILE_CATEGORIES.LLC,
      fileSubCategory: isCoBuyer
        ? FILE_SUB_CATEGORIES.LLC_COBUYER
        : FILE_SUB_CATEGORIES.LLC_BUYER,
    };
  }
  if (entityType === FILE_TYPES.CWCOT) {
    return {
      fileCategory: FILE_CATEGORIES.CWCOT,
      fileSubCategory: getCWCOTSubCategory(primaryEntityType), // Uses primaryEntityType because values are simple
    };
  }
  if (isCABillEntityType(entityType)) {
    return {
      fileCategory: FILE_CATEGORIES.CA_BILL,
      fileSubCategory: getCABillSubCategory(entityType), // Uses entityType because values already include prefix
    };
  }

  // if (entityType === FILE_TYPES.CA_BILL) {
  //   return {
  //     fileCategory: FILE_CATEGORIES.CA_BILL,
  //     fileSubCategory: getCABillSubCategory(primaryEntityType),
  //   };
  // }
  return null;
};
// Helper function to get CWCOT sub-category
const getCWCOTSubCategory = (primaryEntityType) => {
  switch (primaryEntityType) {
    case "hudNonProfit":
      return FILE_SUB_CATEGORIES.CWCOT_NONPROFIT;
    case "government":
      return FILE_SUB_CATEGORIES.CWCOT_BUYER_GOVT;
    case "selfOccupancy":
      return FILE_SUB_CATEGORIES.CWCOT_BUYER_SELF;
    case "ownerOccupied":
      return FILE_SUB_CATEGORIES.CWCOT_OWNER_OCCUPIED;
    case "nonProfitCorp":
      return FILE_SUB_CATEGORIES.CWCOT_NONPROFIT;
    case "landTrust":
      return FILE_SUB_CATEGORIES.CWCOT_LAND_TRUST;
    case "housingCoop":
      return FILE_SUB_CATEGORIES.CWCOT_COOP;
    case "california":
      return FILE_SUB_CATEGORIES.CWCOT_STATE;
    case "cwcotGovernment":
      return FILE_SUB_CATEGORIES.CWCOT_CA_BUYER_GOVT;
    default:
      return null;
  }
};
const getCABillSubCategory = (primaryEntityType) => {
  switch (primaryEntityType) {
    case "caBillOwnerOccupied":
      return FILE_SUB_CATEGORIES.CA_BILL_OWNER_OCCUPIED;
    case "caBillNonProfit":
      return FILE_SUB_CATEGORIES.CA_BILL_NON_PROFIT;
    case "caBillLandTrust":
      return FILE_SUB_CATEGORIES.CA_BILL_LAND_TRUST;
    case "caBillHousingCoop":
      return FILE_SUB_CATEGORIES.CA_BILL_HOUSING_COOP;
    case "caBillCaliforniaState":
      return FILE_SUB_CATEGORIES.CA_BILL_CALIFORNIA_STATE;
    default:
      return null;
  }
};
const validateFile = (file) => {
  console.log("Validating file:", file.name);

  const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
  const ALLOWED_TYPES = ["application/pdf", "image/jpeg", "image/jpg"];

  if (!file) {
    return { isValid: false, error: "No file selected" };
  }

  if (file.size > MAX_FILE_SIZE) {
    return { isValid: false, error: "Maximum file size allowed is 10MB" };
  }

  if (!ALLOWED_TYPES.includes(file.type)) {
    return {
      isValid: false,
      error: "Please upload document in pdf, jpg or jpeg format.",
    };
  }

  return { isValid: true, error: null };
};

// export const handleBusinessFileUpload = async (
//   file,
//   entityType,
//   isCoBuyer,
//   listingId
// ) => {
//   // Validate inputs
//   if (!file || !entityType || !listingId) {
//     return { success: false, error: "Missing required parameters" };
//   }

//   // Validate file
//   const fileValidation = validateFile(file);
//   // console.log("y-----", fileValidation);
//   if (!fileValidation.isValid) {
//     return { success: false, error: fileValidation.error };
//   }

//   // Get file configuration
//   const fileConfig = getFileConfig(entityType, isCoBuyer);
//   if (!fileConfig) {
//     return { success: false, error: "Invalid entity type" };
//   }

//   try {
//     const formData = new FormData();
//     formData.append("file", file);

//     const fileUploadRequest = {
//       listingId,
//       ...fileConfig,
//     };

//     const response = await uploadFileCIF(formData, fileUploadRequest);

//     if (response?.status === "SUCCESS") {
//       return {
//         success: true,
//         data: {
//           fileName: file.name,
//           ...response.data,
//         },
//       };
//     } else {
//       return {
//         success: false,
//         error: response?.message || "Upload failed",
//       };
//     }
//   } catch (error) {
//     return {
//       success: false,
//       error: error.message || "Error uploading file",
//     };
//   }
// };
export const handleBusinessFileUpload = async (
  file,
  entityType,
  isCoBuyer,
  listingId
) => {
  // Validate inputs
  if (!file || !entityType || !listingId) {
    return { success: false, error: "Missing required parameters" };
  }

  // Validate file
  const fileValidation = validateFile(file);
  // console.log("y-----", fileValidation);
  if (!fileValidation.isValid) {
    return { success: false, error: fileValidation.error };
  }

  // Get file configuration
  const fileConfig = getFileConfig(entityType, isCoBuyer);
  if (!fileConfig) {
    return { success: false, error: "Invalid entity type" };
  }

  try {
    const formData = new FormData();
    formData.append("file", file);

    const fileUploadRequest = {
      listingId,
      ...fileConfig,
    };

    const response = await uploadFileCIF(formData, fileUploadRequest);

    if (response?.status === "SUCCESS") {
      return {
        success: true,
        data: {
          fileName: file.name,
          ...response.data,
        },
      };
    } else {
      // Check for specific error code and return message
      if (response?.errorCode === "INVALID_FILE_TYPE") {
        return {
          success: false,
          error: "Please upload document in PDF, JPG or JPEG format.",
        };
      }

      return {
        success: false,
        error: response?.message || "Upload failed",
      };
    }
  } catch (error) {
    return {
      success: false,
      error: error.message || "Error uploading file",
    };
  }
};
export const handleBusinessFileDelete = async (documentId, listingId) => {
  if (!documentId || !listingId) {
    return { success: false, error: "Missing document ID or listing ID" };
  }

  try {
    const response = await deleteFile(documentId, listingId);

    if (response?.data?.status === "SUCCESS") {
      return { success: true };
    } else {
      return {
        success: false,
        error: response?.message || "Delete failed",
      };
    }
  } catch (error) {
    return {
      success: false,
      error: error.message || "Error deleting file",
    };
  }
};
// Add CWCOT file upload handler
export const handleCWCOTFileUpload = async (
  file,
  primaryEntityType,
  isCoBuyer,
  listingId
) => {
  // Validate inputs
  if (!file || !primaryEntityType || !listingId) {
    return { success: false, error: "Missing required parameters" };
  }

  // Validate file
  const fileValidation = validateFile(file);
  if (!fileValidation.isValid) {
    return { success: false, error: fileValidation.error };
  }

  // Get file configuration
  const fileConfig = getFileConfig(
    FILE_TYPES.CWCOT,
    isCoBuyer,
    primaryEntityType
  );
  if (!fileConfig) {
    return { success: false, error: "Invalid entity type" };
  }

  try {
    const formData = new FormData();
    formData.append("file", file);

    const fileUploadRequest = {
      listingId,
      ...fileConfig,
    };

    const response = await uploadFileCIF(formData, fileUploadRequest);

    if (response?.status === "SUCCESS") {
      return {
        success: true,
        data: {
          fileName: file.name,
          ...response.data,
        },
      };
    } else {
      return {
        success: false,
        error: response?.message || "Upload failed",
      };
    }
  } catch (error) {
    return {
      success: false,
      error: error.message || "Error uploading file",
    };
  }
};
// Add this to your existing file upload utility file

export const handleCWCOTFileDelete = async (documentId, listingId) => {
  if (!documentId || !listingId) {
    return { success: false, error: "Missing document ID or listing ID" };
  }

  try {
    // Using the same deleteFile API as business file delete
    const response = await deleteFile(documentId, listingId);

    if (response?.data?.status === "SUCCESS") {
      return { success: true };
    } else {
      return {
        success: false,
        error: response?.message || "Delete failed",
      };
    }
  } catch (error) {
    return {
      success: false,
      error: error.message || "Error deleting file",
    };
  }
};
export const handleCABillFileUpload = async (
  file,
  primaryEntityType,
  isCoBuyer,
  listingId
) => {
  // Validate inputs
  if (!file || !primaryEntityType || !listingId) {
    return { success: false, error: "Missing required parameters" };
  }

  // Validate file
  const fileValidation = validateFile(file);
  if (!fileValidation.isValid) {
    return { success: false, error: fileValidation.error };
  }

  // Get file configuration
  const fileConfig = getFileConfig(primaryEntityType, isCoBuyer);
  if (!fileConfig) {
    return { success: false, error: "Invalid entity type" };
  }

  try {
    const formData = new FormData();
    formData.append("file", file);

    const fileUploadRequest = {
      listingId,
      ...fileConfig,
    };

    const response = await uploadFileCIF(formData, fileUploadRequest);

    if (response?.status === "SUCCESS") {
      return {
        success: true,
        data: {
          fileName: file.name,
          ...response.data,
        },
      };
    } else {
      return {
        success: false,
        error: response?.message || "Upload failed",
      };
    }
  } catch (error) {
    return {
      success: false,
      error: error.message || "Error uploading file",
    };
  }
};
// Add a specific POF file upload handler
export const handlePOFFileUpload = async (file, listingId) => {
  // Validate inputs
  if (!file || !listingId) {
    return { success: false, error: "Missing required parameters" };
  }

  // Validate file
  const fileValidation = validateFile(file);
  if (!fileValidation.isValid) {
    return { success: false, error: fileValidation.error };
  }

  try {
    const formData = new FormData();
    formData.append("file", file);

    const fileUploadRequest = {
      listingId,
      fileCategory: FILE_CATEGORIES.USER_FUND_PROOF,
      fileSubCategory: null,
    };

    const response = await uploadFileCIF(formData, fileUploadRequest);

    if (response?.status === "SUCCESS") {
      return {
        success: true,
        data: {
          fileName: file.name,
          documentId: response.data.documentId,
          listingId: listingId,
          ...response.data,
        },
      };
    } else {
      return {
        success: false,
        error: response?.message || "Upload failed",
      };
    }
  } catch (error) {
    return {
      success: false,
      error: error.message || "Error uploading file",
    };
  }
};
